<template>
    <teleport to="body">
        <div v-if="mostrar" class="modal-overlay" ref="overlay" @click.self="fecharModal">
            <div class="modal-container">
            <!-- Cabeçalho -->
            <div class="modal-header">
                <h6>Cancelar Matrícula</h6>
                <i class="bi bi-x-circle close-icon" @click="fecharModal"></i>
            </div>

            <!-- Conteúdo -->
            <div class="modal-content">
                <!-- Seção: Contrato do Aluno (igual à do Trancar) -->
                <div class="mb-3">
                <h5 class="section-title">Contrato do Aluno</h5>
                <div class="row">
                    <div class="col-md-5">
                    <div class="form-group">
                        <label>Aluno</label>
                        <input type="text" class="form-control" :value="matricula.aluno_nome" disabled />
                    </div>
                    </div>
                    <div class="col-md-3">
                    <div class="form-group">
                        <label>Vigência</label>
                        <input type="text" class="form-control" :value="vigenciaTexto" disabled />
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="form-group">
                        <label>Nº do Contrato</label>
                        <input type="text" class="form-control" :value="matricula.numero_contrato" disabled />
                    </div>
                    </div>
                    <div class="col-md-2">
                    <div class="form-group">
                        <label>Nº da Matrícula</label>
                        <input type="text" class="form-control" :value="matricula.id" disabled />
                    </div>
                    </div>
                </div>
                </div>

                <!-- Seção: Plano Contratado -->
                <div class="mb-3">
                <h5 class="section-title">Plano Contratado</h5>
                <div class="row">
                    <div class="col-md-2">
                    <label>Início da Vigência</label>
                    <input type="text" class="form-control" :value="fmt(matricula.inicio_vigencia)" disabled />
                    </div>
                    <div class="col-md-2">
                    <label>Término da Vigência</label>
                    <input type="text" class="form-control" :value="fmt(matricula.termino_vigencia)" disabled />
                    </div>
                    <div class="col-md-3">
                    <label>Categoria</label>
                    <input type="text" class="form-control" :value="plano.categoria_nome" disabled />
                    </div>
                    <div class="col-md-3">
                    <label>Tipo de Plano</label>
                    <input type="text" class="form-control" :value="plano.tipo_plano_nome" disabled />
                    </div>
                    <div class="col-md-2">
                    <label>Qtd. de Parcelas</label>
                    <input type="text" class="form-control" :value="matricula.quantidade_parcelas" disabled />
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-2">
                    <label>Aulas por Semana</label>
                    <input type="text" class="form-control" :value="matricula.aulas_semana" disabled />
                    </div>
                    <div class="col-md-3">
                    <label>Nível</label>
                    <input type="text" class="form-control" :value="plano.nivel_nome" disabled />
                    </div>
                    <div class="col-md-7">
                    <label>Turmas</label>
                    <textarea class="form-control" :value="turmasFormatadas.join('\n')" rows="2" disabled></textarea>
                    </div>
                </div>
                </div>

                <!-- Seção: Dados Financeiros -->
                <div class="mb-3">
                <h5 class="section-title">Dados Financeiros</h5>
                <div class="table-responsive">
                    <table class="table table-striped table-hover tabela-financeira">
                    <thead>
                        <tr>
                        <th>Vencimento</th>
                        <th>Forma de Pagamento</th>
                        <th>Valor</th>
                        <th>Pagamento</th>
                        <th>Recebimento</th>
                        <th>Obs.</th>
                        <th class="text-end">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="pg in pagamentos" :key="pg.id">
                        <td>{{ fmt(pg.data_vencimento) }}</td>
                        <td>{{ pg.forma_pagamento_nome || '—' }}</td>
                        <td>{{ moeda(pg.valor) }}</td>
                        <td>{{ pg.data_pagamento ? fmt(pg.data_pagamento) : '—' }}</td>
                        <td>{{ pg.data_recebimento ? fmt(pg.data_recebimento) : '—' }}</td>
                        <td>{{ pg.observacoes || '' }}</td>
                        <td class="text-end">
                            <i
                            class="bi mx-1"
                            :class="[
                                'bi-trash-fill',
                                pg.removivel ? (pg.marcar_remocao ? 'text-secondary' : 'text-danger') : 'text-muted'
                            ]"
                            :title="pg.removivel ? (pg.marcar_remocao ? 'Desfazer remoção' : 'Remover (pendente)') : 'Não removível'"
                            :style="{ cursor: pg.removivel ? 'pointer' : 'not-allowed', opacity: pg.removivel ? 1 : 0.5 }"
                            @click="pg.removivel && toggleRemocao(pg)"
                            ></i>
                        </td>
                        </tr>
                        <tr v-if="!pagamentos.length">
                        <td colspan="7" class="text-center text-muted">Nenhum pagamento encontrado para este contrato.</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <!-- <small class="text-muted">
                    Pagamento <strong>removível</strong> = <code>data_pagamento IS NULL</code> ou <code>data_pagamento &gt; hoje</code> (America/Sao_Paulo).
                </small> -->
                </div>
            </div>
            <!-- Rodapé fixo do modal (ver item 2) -->
            <div class="modal-footer">
                <button class="btn btn-outline-secondary" @click="fecharModal" :disabled="isSaving">Fechar</button>
                <button class="btn btn-danger" :disabled="isSaving" @click="confirmarCancelamento">
                {{ isSaving ? 'Cancelando…' : 'Confirmar Cancelamento' }}
                </button>
            </div>
            </div>
        </div>
    </teleport>  
</template>

<script>
import axios from "@/services/axios";
import globalUtils from "@/utils/globalUtils.js";

export default {
  name: "CancelarMatricula",
  emits: ['fechar', 'salvou'],   // 👈 adiciona isto
  props: {
    mostrar: { type: Boolean, default: false },
    matricula: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      plano: {
        categoria_nome: "",
        tipo_plano_nome: "",
        nivel_nome: "",
      },
      turmasFormatadas: [],
      pagamentos: [],
    };
  },
  computed: {
    vigenciaTexto() {
      return `${this.fmt(this.matricula.inicio_vigencia)} a ${this.fmt(this.matricula.termino_vigencia)}`;
    },
  },
  watch: {
    async mostrar(v) {
        if (v) {
        document.body.style.overflow = 'hidden';   // bloqueia scroll do fundo
        await this.carregarDados();
        } else {
        document.body.style.overflow = '';         // libera scroll
        }
    },
  },

  beforeUnmount() {
    document.body.style.overflow = '';
  },
  
  methods: {
    async withOverlayBehindConfirm(runConfirm) {
        const el = this.$refs.overlay;
        const prev = el?.style.zIndex;
        // deixa abaixo de modais Bootstrap (1050) / de muitos plugins
        if (el) el.style.zIndex = '900';
        try {
        return await runConfirm();
        } finally {
        if (el) el.style.zIndex = prev || '20000';
        }
    },
    fmt(d) {
      const f = globalUtils?.formatarData;
      if (typeof f === "function") return f(d);
      // fallback simples
      if (!d) return "";
      try {
        const dd = new Date(d);
        return dd.toLocaleDateString("pt-BR");
      } catch { return String(d); }
    },
    moeda(v) {
      const f = globalUtils?.formatarMoeda;
      if (typeof f === "function") return f(v);
      // fallback BRL
      const n = Number(v ?? 0);
      try {
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(isNaN(n) ? 0 : n);
      } catch {
        return `R$ ${isNaN(n) ? "0,00" : n.toFixed(2).replace(".", ",")}`;
      }
    },
    fecharModal() {
      this.$emit("fechar");
    },
    // yyyy-mm-dd local (America/Sao_Paulo no browser já atende)
    hojeLocalISO() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth()+1).padStart(2,'0');
      const d = String(now.getDate()).padStart(2,'0');
      return `${y}-${m}-${d}`;
    },
    marcarRemovivelFlag(items) {
      const hoje = this.hojeLocalISO();
      return (items || []).map(pg => {
        const dp = pg.data_pagamento ? String(pg.data_pagamento).substring(0,10) : null;
        const removivel = (!dp) || (dp > hoje);
        return { ...pg, removivel, marcar_remocao: false };
      });
    },
    toggleRemocao(pg) {
      pg.marcar_remocao = !pg.marcar_remocao;
    },
    async carregarDados() {
      this.isLoading = true;
      this.turmasFormatadas = [];
      this.pagamentos = [];
      try {
        // Endpoint agregado (recomendado)
        const { data } = await axios.get(`/operacional/matriculas-cancelamentos/${this.matricula.id}/dados`, {
            params: { contrato: this.matricula.numero_contrato }
        });


        // Plano
        this.plano = {
          categoria_nome: data.plano?.categoria_nome || "",
          tipo_plano_nome: data.plano?.tipo_plano_nome || "",
          nivel_nome: data.plano?.nivel_nome || "",
        };

        // Turmas
        this.turmasFormatadas = (data.turmas || []).map(t =>
          `Turma: ${t.turma_id} | Dia: ${t.dia_semana} | Hora: ${String(t.horario).substring(0,5)} | Instrutor: ${t.instrutor_nome}`
        );

        // Pagamentos (já pode vir com removível calculado no backend; se não vier, calculo aqui)
        this.pagamentos = Array.isArray(data.pagamentos) && data.pagamentos.length
          ? (data.pagamentos[0].removivel !== undefined ? data.pagamentos
              : this.marcarRemovivelFlag(data.pagamentos))
          : [];
      } catch (e) {
        console.error("Erro ao carregar dados de cancelamento:", e);
        // fallback mínimo: montar nomes com campos já presentes na matrícula (se não houver endpoint)
        this.plano = {
          categoria_nome: this.matricula.categoria_nome || "",
          tipo_plano_nome: this.matricula.tipo_plano_nome || "",
          nivel_nome: this.matricula.nivel_nome || "",
        };
      } finally {
        this.isLoading = false;
      }
    },
    async confirmarCancelamento() {
      if (this.isSaving) return;
      const confirmou = await this.withOverlayBehindConfirm(() => {
        if (this.$confirm) {
            return this.$confirm(
            "Confirma o cancelamento desta matrícula? Esta ação ajustará a vigência e poderá remover pagamentos pendentes marcados.",
            "Confirmação"
            );
        }
        // fallback nativo
        return Promise.resolve(window.confirm(
            "Confirma o cancelamento desta matrícula? Esta ação ajustará a vigência e poderá remover pagamentos pendentes marcados."
        ));
      });

      if (!confirmou) return;

      this.isSaving = true;
      try {
        const hoje = this.hojeLocalISO();
        const pagamentosParaRemover = this.pagamentos
          .filter(p => p.removivel && p.marcar_remocao)
          .map(p => p.id);

        const userName = (this.$globalState && this.$globalState.userName) ? this.$globalState.userName : 'Usuário';

        const payload = {
          matricula_id: this.matricula.id,
          numero_contrato: this.matricula.numero_contrato,
          data_cancelamento: hoje,
          pagamentos_para_remover: pagamentosParaRemover,
          nome_usuario: userName,
        };

        const res = await axios.post(`/operacional/matriculas-cancelamentos/${this.matricula.id}/cancelar`, payload);
        this.$toast && this.$toast.success("Matrícula cancelada com sucesso!");
        this.$emit("salvou", res.data);
        this.fecharModal();
      } catch (e) {
        console.error("Erro ao cancelar matrícula:", e);
        this.$alert && this.$alert(e.response?.data?.error || e.response?.data?.detail || "Não foi possível cancelar a matrícula.", "Erro");
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.5);
  z-index: 20000;                /* bem acima da UI */
  display: flex; align-items: center; justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: min(1200px, 95%);
  max-height: 90vh;              /* limita altura total */
  border-radius: 4px; overflow: hidden;

  display: flex;                 /* header / content / footer */
  flex-direction: column;
}

.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex; justify-content: space-between; align-items: center;
}

.modal-content {
  padding: 15px;
  overflow-y: auto;              /* conteúdo rola */
  flex: 1;                       /* ocupa o meio */
}

.modal-footer {
  padding: 10px 15px;            /* rodapé sempre visível */
  background: #fff;
  border-top: 1px solid #e5e7eb;
  display: flex; justify-content: flex-end; gap: .5rem;
}

.close-icon { font-size: 1.5rem; cursor: pointer; }
label { font-size: .8rem; font-weight: 500; }
.section-title { font-size: .9rem; font-weight: bold; margin-bottom: 10px; }

.tabela-financeira {
  min-width: 860px;
}

.tabela-financeira th,
.tabela-financeira td:not(:nth-child(6)) {
  white-space: nowrap;
}

@media (max-width: 992px) {
  .modal-container { max-width: 95%; }
}
</style>